import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ApiError {
  status: number;
  message: string;
  errors?: Record<string, string[]>;
}

@Injectable({ providedIn: 'root' })
export class BaseApiService {
  protected readonly http = inject(HttpClient);
  protected baseUrl = '';

  setBaseUrl(url: string): void {
    this.baseUrl = url;
  }

  protected buildParams(params: Record<string, unknown>): HttpParams {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }

  protected handleError(error: unknown): Observable<never> {
    return throwError(() => error);
  }

  protected get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http
      .get<T>(url, { params })
      .pipe(catchError((e) => this.handleError(e)));
  }

  protected post<T>(url: string, body: unknown): Observable<T> {
    return this.http
      .post<T>(url, body)
      .pipe(catchError((e) => this.handleError(e)));
  }

  protected put<T>(url: string, body: unknown): Observable<T> {
    return this.http
      .put<T>(url, body)
      .pipe(catchError((e) => this.handleError(e)));
  }

  protected patch<T>(url: string, body: unknown): Observable<T> {
    return this.http
      .patch<T>(url, body)
      .pipe(catchError((e) => this.handleError(e)));
  }

  protected delete<T>(url: string): Observable<T> {
    return this.http
      .delete<T>(url)
      .pipe(catchError((e) => this.handleError(e)));
  }
}
